// GENERATED by scripts/shadertoy/vendor-shaders.mjs — do not edit by hand.
//
// Shadertoy shaders vendored into the repo so the render path never depends on the
// network. Regenerate with:
//
//   node scripts/shadertoy/vendor-shaders.mjs <id> [id …]
//
// Empty for now: the API sits behind a Cloudflare bot challenge that a shell client
// cannot satisfy, so nothing has been pulled down yet. Every id present here is served
// from source and never fetched; ids absent from it fall through to the live API.
//
// Every entry is screened single-pass with no bound channel beyond the audio texture on
// iChannel0. LICENSING: Shadertoy's default is CC BY-NC-SA 3.0 unless the author states
// otherwise, and the NC clause bites on monetized output — check each shader's
// description before shipping it in a social clip.

export default {} as Record<string, {name: string, username: string, code: string}>
